var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinPnc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90431 1.74569C7.0769 1.44676 7.45915 1.34434 7.75808 1.51693L13.5316 4.85026C13.8305 5.02285 13.9329 5.40509 13.7603 5.70403C13.5878 6.00296 13.2055 6.10538 12.9066 5.93279L12.0873 5.45977L10.3929 9.68103C10.5843 9.99373 10.7451 10.3228 10.8706 10.6639C11.3484 11.9629 11.2761 13.3402 10.6204 14.4759C10.4478 14.7749 10.0656 14.8773 9.76662 14.7047L5.97776 12.5172L4.20693 15.5844C4.03434 15.8833 3.6521 15.9857 3.35316 15.8131C3.05423 15.6405 2.95181 15.2583 3.1244 14.9594L4.89523 11.8922L1.10637 9.70469C0.807437 9.5321 0.705015 9.14986 0.877604 8.85093C1.53332 7.7152 2.68991 6.96396 4.05383 6.72824C4.412 6.66634 4.77733 6.64106 5.14384 6.65046L7.95237 3.07248L7.13308 2.59946C6.83415 2.42687 6.73172 2.04463 6.90431 1.74569Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinPnc);
export default __webpack_public_path__ + "static/media/pinPnc.84e6db610a10338d73dae5c54eeab630.svg";
export { ForwardRef as ReactComponent };